import { Spin, Timeline, Typography } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IGlobalState } from '~reducer';
import Layout from './Layout';
import ILoanPaymentAbaHistory from '~Api/LoanPaymentAba/ILoanPaymentAbaHistory';
import { loanPaymentAbaHistoriesSelector } from '~LoanPaymentAbas/selectors';
import { loanPaymentAbaHistoriesListAction } from '~LoanPaymentAbas/actions';

export default function History(): ReactElement {
    const { loanPaymentAbaUuid } = useParams<{ loanPaymentAbaUuid: string }>();

    const histories: ILoanPaymentAbaHistory[] = useSelector((state: IGlobalState) => loanPaymentAbaHistoriesSelector(state, loanPaymentAbaUuid));

    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        if (!histories) {
            dispatch(loanPaymentAbaHistoriesListAction(loanPaymentAbaUuid));
        }
    }, [
        dispatch,
        histories,
        loanPaymentAbaUuid,
    ]);

    if (!histories) {
        return (
            <Layout pageTitle='History' section='history' uuid={loanPaymentAbaUuid}>
                <Typography.Title level={2}>History</Typography.Title>
                <Spin/>
            </Layout>
        );
    }

    const historiesBlock: JSX.Element[] = _.sortBy(histories, [ 'createdTime' ]).map((history: ILoanPaymentAbaHistory) => (
        <Timeline.Item key={history.uuid} label={dayjs(history.createdTime).format('YYYY-MM-DD - HH:mm')}>
            <Typography.Text>{history.description}</Typography.Text>
        </Timeline.Item>
    ));

    return (
        <Layout pageTitle='History' section='history' uuid={loanPaymentAbaUuid}>
            <Typography.Title level={2}>History</Typography.Title>
            <Timeline mode='left' reverse={true}>
                {historiesBlock}
            </Timeline>
        </Layout>
    );
}